import { AfterViewInit, Component } from '@angular/core';
import { AuthService } from '../../../services';
import { translationKeys } from '../../../core';

@Component({
  selector: 'scip-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements AfterViewInit {
  translationKeys: typeof translationKeys = translationKeys;

  constructor(private authService: AuthService) {}

  ngAfterViewInit(): void {
    this.authService.logout();
  }
}
